import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

/**
 * Client-side 404 shown when a user lands on an unknown route while the
 * SPA is already loaded. A static `public/404.html` is also present for
 * server-level 404s (e.g. when the SPA fallback isn't configured).
 */
export default function NotFoundPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = 'Off the trail · The Curd Compass';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-6">
      <div className="max-w-xl text-center space-y-6">
        <Compass className="mx-auto text-accent" size={48} />
        <p className="text-[11px] uppercase tracking-widest text-ink-light font-bold">404</p>
        <h1 className="text-4xl md:text-5xl font-serif text-ink leading-[1.1]">
          You've wandered off the trail.
        </h1>
        <p className="text-ink-light leading-relaxed">
          The page you were looking for isn't here. The Curd Compass is a small
          editorial guide — most wrong turns land back on the map.
        </p>
        <div className="pt-2">
          <Link to="/" className="btn-minimal inline-flex items-center gap-2">
            <ArrowLeft size={14} /> Back to the trail
          </Link>
        </div>
      </div>
    </div>
  );
}
